import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  // A BehaviorSubject to hold the sidebar's visibility state (true for visible, false for hidden)
  private sidebarVisibility = new BehaviorSubject<boolean>(false);

  // Observable to allow other components to subscribe to sidebar changes
  sidebarVisibility$ = this.sidebarVisibility.asObservable();

  // Function to change the sidebar visibility
  toggleSidebar(isOpen: boolean) {
    this.sidebarVisibility.next(isOpen);
  }
}
